module.exports = __webpack_public_path__ + "img/fengxian.e12a08e7.jpg";